<template>
  <div>
    <hotel
        :value.sync="hotel"
        :beforeSubmit="validateRooms"
        :afterSubmit="submitRooms"
    >
      <!--      <rooms ref="roomsComp" :rooms="rooms"/>-->
    </hotel>
  </div>
</template>
<script>
import {reactive, ref} from 'vue'
import Hotel from './Hotel.vue'
import ImageUploader from '../../../components/ImageUploader'
import Rooms from './Rooms'
import {useRouter} from "vue-router";

const roomItem = {
  name: '',
  desc: '',
  pictures: []
}

const emptyHotel = {
  name: '',
  pictures: [],
  description: '',
  division: [],
  division_detail: '',
  location: ''
}

export default {
  components: {Hotel, ImageUploader, Rooms},
  setup() {
    const hotel = reactive({...emptyHotel})

    const rooms = reactive([
      // {...JSON.parse(JSON.stringify(roomItem))}
    ])

    const roomsComp = ref('')

    const validateRooms = () => {
      // return roomsComp.value?.validateRooms()
    }

    const router = useRouter()
    const submitRooms = id => {
      // return roomsComp.value?.submitRooms(id)
      // router.replace(`/hotels/${id}/edit`)
      Object.assign(hotel, {...emptyHotel})
    }

    return {
      roomsComp,
      submitRooms,
      validateRooms,
      hotel,
      rooms,
      log: console.log
    }
  }
}
</script>
<style scoped>
</style>
